import { Helmet } from 'react-helmet';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { loginCommercialSteps } from './LoginENT.data';

export default () => {
  return (
    <>
      <Helmet>
        <title>Connexion entreprise</title>
      </Helmet>
      <StepWizard steps={loginCommercialSteps} isCompany />
    </>
  );
};
